<template>
  <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
    <i :class="'vs-icon notranslate icon-scale material-icons'">{{subscriberIcon(params.value)}}</i>
  </vs-chip>
</template>

<script>
export default {
  name: "CellRendererStatus",
  computed: {
    chipColor() {
      return (value) => {
        if (value === true) {
          return "success";
        } else if (value === false) return "danger";
      };
    },
    subscriberIcon(){
      return (value) => {
        if (value === true) {
          return "done";
        } else if (value === false) return "cancel";
      };
    }
  },
};
</script>

<style lang="scss" scpoped>
.ag-grid-cell-chip {
  &.vs-chip-success {
    background: rgba(var(--vs-success), 0.15);
    color: rgba(var(--vs-success), 1) !important;
    font-weight: 500;
  }
  &.vs-chip-danger {
    background: rgba(var(--vs-danger), 0.15);
    color: rgba(var(--vs-danger), 1) !important;
    font-weight: 500;
  }
}
</style>
